module.exports = __webpack_public_path__ + "img/icon66.1f9dca4a.png";